import React from "react";
import Navbar from "../../layout/Navbar";
import Footer from "../../layout/Footer";
import Hero from "../../layout/Hero";
import Counts from "../../layout/Counts";
import Features from "../../layout/Features";
import Reviews from "../../layout/Reviews";
import CallToAction from "../../layout/CallToAction";
import Faqs from "../../layout/Faqs";

const HomePage = () => {
    return (
        <>
            <Navbar />
             <main class="">
            <Hero />
            <Counts />
            <Features />
            {/* <Reviews /> */}
            <CallToAction />
            <Faqs />

            </main>
            <Footer />
        </>
    )
}
export default HomePage;